import { TransactionModal } from "@/components/transactions/TransactionModal";
import { ImportStatementModal } from "@/components/import/ImportStatementModal";
import { CreditCardInvoiceModal } from "@/components/credit-card/CreditCardInvoiceModal";
import { AccountModal } from "@/components/shared/AccountModal";

interface DashboardModalsProps {
  showTransactionModal: boolean;
  setShowTransactionModal: (open: boolean) => void;
  showImportModal: boolean;
  setShowImportModal: (open: boolean) => void;
  showInvoiceModal: boolean;
  setShowInvoiceModal: (open: boolean) => void;
  showAccountModal: boolean;
  setShowAccountModal: (open: boolean) => void;
  showEditTransactionModal: boolean;
  setShowEditTransactionModal: (open: boolean) => void;
  selectedCreditCardId: string | null;
  selectedAccountForImport: string | null;
  selectedAccount: any | null;
  editingTransaction: any | null;
  defaultTransactionAccountId: string | null;
  setDefaultTransactionAccountId: (id: string | null) => void;
  setSelectedAccountForImport: (id: string | null) => void;
  setEditingTransaction: (tx: any | null) => void;
  setCreditCardRefreshKey: React.Dispatch<React.SetStateAction<number>>;
  fetchData: () => Promise<void>;
  accountCounts?: { checking: number; savings: number; credit_card: number };
}

export function DashboardModals({
  showTransactionModal,
  setShowTransactionModal,
  showImportModal,
  setShowImportModal,
  showInvoiceModal,
  setShowInvoiceModal,
  showAccountModal,
  setShowAccountModal,
  showEditTransactionModal,
  setShowEditTransactionModal,
  selectedCreditCardId,
  selectedAccountForImport,
  selectedAccount,
  editingTransaction,
  defaultTransactionAccountId,
  setDefaultTransactionAccountId,
  setSelectedAccountForImport,
  setEditingTransaction,
  setCreditCardRefreshKey,
  fetchData,
  accountCounts,
}: DashboardModalsProps) {
  return (
    <>
      <TransactionModal
        open={showTransactionModal}
        onOpenChange={(open) => {
          setShowTransactionModal(open);
          if (!open) setDefaultTransactionAccountId(null);
        }}
        onSuccess={fetchData}
        defaultAccountId={defaultTransactionAccountId || undefined}
      />

      <ImportStatementModal
        open={showImportModal}
        onOpenChange={(open) => {
          setShowImportModal(open);
          if (!open) setSelectedAccountForImport(null);
        }}
        onSuccess={fetchData}
        defaultAccountId={selectedAccountForImport}
      />

      <CreditCardInvoiceModal
        open={showInvoiceModal}
        onOpenChange={setShowInvoiceModal}
        creditCardId={selectedCreditCardId}
        onSuccess={() => {
          fetchData();
          setCreditCardRefreshKey(prev => prev + 1);
        }}
      />

      <AccountModal
        open={showAccountModal}
        onOpenChange={setShowAccountModal}
        account={selectedAccount}
        onSuccess={fetchData}
        accountCounts={accountCounts}
      />

      <TransactionModal
        open={showEditTransactionModal}
        onOpenChange={(open) => {
          setShowEditTransactionModal(open);
          if (!open) setEditingTransaction(null);
        }}
        onSuccess={fetchData}
        transaction={editingTransaction}
      />
    </>
  );
}
